import $ from 'jquery';

export default class ModalSearchInput {
    constructor() {
        this.$searchForm = null;
        this.$searchFormInput = null;
    }
    init() {
        this.$searchForm = $('.search-form');
        this.$searchFormInput = $('.search-form__input');
        this.inputEvents();
    }

    inputEvents() {
        this.$searchFormInput.on('input', () => {
            if (this.$searchFormInput.val()) {
                this.$searchForm.removeClass('search-form--empty');
            } else{
                this.$searchForm.addClass('search-form--empty');
            }
            //TODO: SOME TREATMENT HERE FOR AUTOCOMPLETE
        });

    }
}
